import React, { memo } from 'react'

import { bool, string } from 'prop-types'

import { AI_TERMS_OF_SERVICE_HREF } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function AiTermsNotice({ leadTextKey = 'usageModal.terms.leadDefault', small = false }) {
  const t = useTranslation()
  const className = [
    'usage-modal__terms',
    small ? 'usage-modal__terms--compact cgt-caption' : 'cgt-body-base',
  ].join(' ')

  return (
    <p className={className}>
      {t(leadTextKey)}
      {' '}
      <a
        href={AI_TERMS_OF_SERVICE_HREF}
        target="_blank"
        rel="noopener noreferrer"
        className="cgt-link-primary-accented"
      >
        {t('usageModal.terms.tosLink')}
      </a>
      .
    </p>
  )
}

AiTermsNotice.propTypes = {
  leadTextKey: string,
  small: bool,
}

export default memo(AiTermsNotice)
